export const defaultSettings = {
  text: 'blocks.button.default.text',
  url: '',
  width: '220',
  height: '40',
  fontSize: '14',
  fontWeight: 'normal',
  borderRadius: '3',
  backgroundColor: '#444444',
  textColor: '#ffffff',
  align: 'center',
}

export const DEFAULT_PADDING = 30
